import { PermissiblePurposesListDocument, usePermissiblePurposeUpdateMutation } from 'src/api';

import { useNotification } from '../app';

export const usePermissiblePurposeUpdate = () => {
  const { createApolloContext } = useNotification();

  const [updatePermissiblePurpose] = usePermissiblePurposeUpdateMutation({
    context: createApolloContext({
      errorMessage: 'Failed to update Permissible Purpose',
      successMessage: 'Permissible Purpose successfully updated',
    }),
    refetchQueries: [PermissiblePurposesListDocument],
  });

  return { updatePermissiblePurpose };
};
